<template>
  <ul>
    <li v-for="page in pages" :key="page.id" class="mb-2">
      <router-link
        :to="'/material/' + page.path"
        class="font-bold text-green hover:text-green-dark"
      >
        {{ page.title }}
      </router-link>
      <span class="block text-xs text-gray-500">{{ page.path }}</span>
    </li>
  </ul>
</template>

<script setup>
defineProps({
  pages: {
    type: Array,
    required: true,
  },
})
</script>

<style scoped></style>
